export const tickerItems = [
  { time: "12:38", text: "某选秀综艺舞台翻车现场复盘：剪辑、音准与评审口径争议再刷屏" },
  { time: "11:52", text: "直播带货「全网最低价」话术监管收紧，业内复盘口碑翻车六大雷区" },
  { time: "10:26", text: "数据打投整治一周年：粉丝圈层生态出现哪些结构性变化" },
  { time: "09:40", text: "年度影视片约变动图谱发布：从官宣到辞演的时间线全整理" },
  { time: "08:15", text: "综艺人设『考古』成新常态，早期言论被重新审视的讨论升温" },
];

export const hero = {
  kicker: "头版头条 · 全网焦点",
  title: "一场跨平台舆论风暴的时间线：从发酵到反转，谁在推动『瓜熟蒂落』",
  summary:
    "当同一个话题在剧集粉、选秀圈与品牌方之间来回撕扯，热度并不来自单一事件，而来自被反复拆解的时间节点。本图鉴将该话题按人物发声、品牌回应、网友考古三段梳理，帮你把散落各处的讨论一次看全。",
  tags: ["舆论复盘", "事件时间线", "多方视角"],
  heat: "23.8万热度",
  reading: "约 12 分钟读完",
  image:
    "https://readdy.ai/api/search-image?query=Moody%20editorial%20magazine%20cover%20showing%20a%20dark%20stage%20with%20a%20single%20spotlight%2C%20floating%20newspaper%20clippings%20and%20phone%20screens%20silhouettes%20in%20shadow%2C%20warm%20amber%20and%20deep%20ink%20tones%2C%20cinematic%20contrast%2C%20clean%20modern%20graphic%20composition%2C%20no%20text&width=1400&height=740&seq=hero-main-2026&orientation=landscape",
};

export const guideCards = [
  {
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20backstage%20rehearsal%20room%20with%20microphone%20and%20stage%20lights%20off%2C%20moody%20low%20key%20warm%20lighting%2C%20cinematic%20press%20photography%2C%20clean%20composition%2C%20no%20people%20faces&width=560&height=400&seq=guide-1-2026&orientation=landscape",
    title: "舞台综艺排播调整背后：『档期』与『舆情』的联动复盘",
    label: "综艺",
    heat: "9.6万",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Overhead%20editorial%20shot%20of%20a%20live%20streaming%20studio%20desk%20with%20ring%20light%20and%20monitors%20showing%20blurred%20charts%2C%20warm%20tungsten%20tones%2C%20cinematic%20dark%20background%2C%20product%20review%20aesthetic%2C%20no%20faces&width=560&height=400&seq=guide-2-2026&orientation=landscape",
    title: "直播翻车盘点方法论：那些被逐条回放的『金句』如何定型人设",
    label: "直播",
    heat: "7.2万",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20collage%20of%20vintage%20film%20reels%20and%20camera%20lenses%20in%20warm%20sepia%20tone%2C%20dark%20cinematic%20background%2C%20media%20archives%20concept%2C%20moody%20and%20clean%2C%20no%20text&width=560&height=400&seq=guide-3-2026&orientation=landscape",
    title: "早期作品考古为何总在爆发前夜：一次『旧事重提』的传播链条",
    label: "考古",
    heat: "5.8万",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20life%20of%20a%20brand%20contract%20document%20with%20red%20stamp%20seal%20on%20dark%20wood%20desk%2C%20warm%20cinematic%20light%2C%20corporate%20crisis%20narrative%2C%20clean%20moody%20composition%2C%20no%20readable%20text&width=560&height=400&seq=guide-4-2026&orientation=landscape",
    title: "品牌解约时间表图鉴：从观望到切割的每一步都有人标注",
    label: "商务",
    heat: "4.4万",
  },
];

export const hotTop = [
  { rank: 1, title: "跨平台舆论风暴·全时间线", tag: "头版", heat: "238K", up: "▲ 12%", trend: "peak" },
  { rank: 2, title: "数据打投整治周年复盘", tag: "行业", heat: "196K", up: "▲ 8%", trend: "up" },
  { rank: 3, title: "综艺排播调整档期联动", tag: "综艺", heat: "171K", up: "▲ 21%", trend: "up" },
  { rank: 4, title: "直播「全网最低价」监管收紧", tag: "直播", heat: "149K", up: "▲ 5%", trend: "up" },
  { rank: 5, title: "早期言论考古再审视", tag: "考古", heat: "128K", up: "▼ 3%", trend: "down" },
  { rank: 6, title: "影视片约变动发布图谱", tag: "影视", heat: "112K", up: "— 0%", trend: "flat" },
  { rank: 7, title: "商务解约时间表图鉴", tag: "商务", heat: "96K", up: "▲ 9%", trend: "up" },
  { rank: 8, title: "直播金句人设定型复盘", tag: "直播", heat: "83K", up: "▲ 4%", trend: "up" },
  { rank: 9, title: "综艺评审口径争议回顾", tag: "综艺", heat: "71K", up: "▼ 2%", trend: "down" },
  { rank: 10, title: "剧集粉圈口碑分化观察", tag: "剧集", heat: "58K", up: "— 0%", trend: "flat" },
];

export const riseItems = [
  { title: "品牌沉默期解读：删帖、置顶与换头像的三个信号", label: "解读" },
  { title: "粉丝反黑应援手册正被重新讨论边界", label: "圈层" },
  { title: "选秀回锅选手口碑两极：导演剪辑权力被点名", label: "行业" },
  { title: "剧集注水剪辑成新舆论靶点", label: "剧集" },
  { title: "『官宣又撤回』舆情操作被逐帧分析", label: "案例" },
];

export const catalogGroups = [
  {
    name: "人物",
    desc: "以圈层身份为索引，汇总被反复热议的个体履历与争议节点",
    items: [
      {
        cover:
          "https://readdy.ai/api/search-image?query=Editorial%20portrait%20shadow%20of%20a%20young%20singer%20silhouette%20behind%20frosted%20glass%20with%20stage%20backlight%2C%20moody%20warm%20tone%2C%20cinematic%20press%20style%2C%20identity%20hidden%2C%20no%20face&width=500&height=360&seq=cata-person-1-2026&orientation=landscape",
        title: "选秀出道新生·履历争议节点",
        mark: "人物 / 唱跳",
        intro: "从训练生合约到出道后言论，按年份归档每一次被截取放大的片段。",
        tags: ["出道", "合约", "舞台"],
        comments: "1.2k",
      },
      {
        cover:
          "https://readdy.ai/api/search-image?query=Editorial%20silhouette%20of%20a%20film%20actor%20facing%20a%20bright%20cinema%20screen%20in%20a%20dark%20theater%2C%20warm%20amber%20backlight%2C%20cinematic%20portrait%20of%20identity%2C%20no%20visible%20face&width=500&height=360&seq=cata-person-2-2026&orientation=landscape",
        title: "转型演员·旧访谈被重读",
        mark: "人物 / 演员",
        intro: "当角色滤镜叠加现实人设，早期访谈开始被逐句对照当下的立场。",
        tags: ["访谈", "转型", "对照"],
        comments: "986",
      },
      {
        cover:
          "https://readdy.ai/api/search-image?query=Editorial%20view%20of%20a%20podcast%20microphone%20and%20notebook%20on%20a%20dark%20table%20with%20warm%20desk%20lamp%2C%20voice%20creator%20narrative%2C%20moody%20cinematic%2C%20no%20faces&width=500&height=360&seq=cata-person-3-2026&orientation=landscape",
        title: "播客主理人·言论索引整理",
        mark: "人物 / 播客",
        intro: "一期节目中的即兴表述，如何在被二次传播后成为固定标签。",
        tags: ["播客", "即兴", "传播"],
        comments: "742",
      },
    ],
  },
  {
    name: "事件",
    desc: "以话题为主线，把碎片化讨论还原为可追溯的事件全貌",
    items: [
      {
        cover:
          "https://readdy.ai/api/search-image?query=Editorial%20abstract%20of%20a%20phone%20screen%20showing%20blurred%20comment%20threads%20with%20fire%20emoji%20light%20glow%20in%20dark%2C%20warm%20red%20tone%2C%20viral%20moment%20concept%2C%20cinematic%2C%20no%20readable%20text&width=500&height=360&seq=cata-event-1-2026&orientation=landscape",
        title: "跨平台热搜连环瓜·发酵全程",
        mark: "事件 / 舆论",
        intro: "一条爆料如何跨平台蔓延，热度曲线的每个波峰对应哪个节点。",
        tags: ["热搜", "发酵", "曲线"],
        comments: "2.4k",
      },
      {
        cover:
          "https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20brand%20signboard%20being%20removed%20from%20a%20storefront%20at%20night%2C%20warm%20street%20light%2C%20moody%20cinematic%2C%20sponsorship%20end%20concept%2C%20no%20faces&width=500&height=360&seq=cata-event-2-2026&orientation=landscape",
        title: "赞助商集体观望与切割·节奏表",
        mark: "事件 / 商务",
        intro: "从联合声明到个别解约，品牌节奏差异背后的风险评估逻辑。",
        tags: ["解约", "观望", "风险"],
        comments: "1.5k",
      },
      {
        cover:
          "https://readdy.ai/api/search-image?query=Editorial%20arrangement%20of%20vintage%20newspapers%20and%20magnifying%20glass%20on%20a%20dark%20desk%2C%20warm%20desk%20lamp%20light%2C%20investigation%20archive%20concept%2C%20cinematic%20moody%2C%20no%20readable%20text&width=500&height=360&seq=cata-event-3-2026&orientation=landscape",
        title: "旧闻考古潮·被重新定价的发言",
        mark: "事件 / 考古",
        intro: "过去被忽视的边角料，如何在新的语境里成为主要讨论对象。",
        tags: ["考古", "语境", "定价"],
        comments: "608",
      },
    ],
  },
  {
    name: "类型",
    desc: "按瓜的形态归纳，从偷拍到言论，一本可对号入座的操作指南",
    items: [
      {
        cover:
          "https://readdy.ai/api/search-image?query=Editorial%20dark%20view%20of%20a%20recording%20app%20waveform%20on%20phone%20screen%20next%20to%20earbuds%2C%20warm%20orange%20tone%2C%20leak%20concept%2C%20cinematic%2C%20no%20readable%20text&width=500&height=360&seq=cata-type-1-2026&orientation=landscape",
        title: "音频类瓜·声道与前后文",
        mark: "类型 / 音频",
        intro: "一段音频的截取时长、剪辑顺序如何影响吃瓜节奏。",
        tags: ["音频", "剪辑", "声道"],
        comments: "1.1k",
      },
      {
        cover:
          "https://readdy.ai/api/search-image?query=Editorial%20macro%20shot%20of%20screenshot%20corners%20on%20a%20phone%20screen%20showing%20blurred%20chat%20bubbles%2C%20warm%20light%2C%20chat%20record%20concept%2C%20moody%20cinematic%2C%20no%20readable%20text&width=500&height=360&seq=cata-type-2-2026&orientation=landscape",
        title: "截图类瓜·时间戳与上下文",
        mark: "类型 / 截图",
        intro: "聊天截图常因缺上下文翻车，本类归档教你识别断章信号。",
        tags: ["截图", "时间戳", "上下文"],
        comments: "874",
      },
      {
        cover:
          "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20dark%20stage%20curtain%20with%20a%20single%20warm%20spotlight%20creating%20silhouette%20of%20a%20person%20bowing%2C%20statement%20and%20apology%20concept%2C%20cinematic%2C%20no%20face&width=500&height=360&seq=cata-type-3-2026&orientation=landscape",
        title: "声明与致歉·话术拆解集",
        mark: "类型 / 声明",
        intro: "从避重就轻到全盘认领，把常见公关话术归档为对照表。",
        tags: ["声明", "话术", "拆解"],
        comments: "1.9k",
      },
    ],
  },
];

export const timeline = [
  { period: "第1天", point: "源头曝光", items: [{ title: "单条爆料开始扩散，核心时间戳被标注", meta: "源头 · 传播起点" }] },
  { period: "第2-3天", point: "多方下场", items: [{ title: "当事人未回应，二次传播进入『等反转』阶段", meta: "发酵 · 话题扩圈" }] },
  { period: "第4-6天", point: "考古潮", items: [{ title: "早期作品与旧访谈被逐帧翻出，时间线被补全", meta: "考古 · 语境重建" }] },
  { period: "第7-9天", point: "商务表态", items: [{ title: "品牌陆续观望或切割，解约时间表被整理成图鉴", meta: "商务 · 风险落地" }] },
  { period: "第10天+", point: "官方定性", items: [{ title: "声明或说明发布，话题进入收尾与长尾讨论", meta: "定性 · 舆情回落" }] },
];

export const cardFlow = [
  {
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20wide%20shot%20of%20a%20dark%20concert%20stage%20with%20empty%20seats%20and%20floating%20dust%20in%20a%20single%20beam%20of%20light%2C%20warm%20amber%20tone%2C%20cinematic%20review%20narrative%2C%20no%20faces&width=700&height=440&seq=flow-1-2026&orientation=landscape",
    title: "一场演唱会口碑两极复盘：舞美、票价与粉丝经济的账本",
    kind: "深度长文",
    summary: "主办方、票务与演出方各自承担哪一环，热度背后是完整的商业账目。",
    read: "8.2k",
    like: "1.1k",
  },
  {
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20stack%20of%20film%20festival%20award%20trophies%20in%20soft%20warm%20light%20on%20a%20dark%20podium%2C%20moody%20cinematic%2C%20award%20controversy%20narrative%2C%20no%20readable%20engraving&width=700&height=440&seq=flow-2-2026&orientation=landscape",
    title: "奖项名单官宣后，舆论为何总是『意难平』占多数",
    kind: "议题观察",
    summary: "评审标准不透明时，讨论会滑向对『陪跑名单』的集体考古。",
    read: "6.4k",
    like: "934",
  },
  {
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20dark%20studio%20shot%20of%20tangled%20fiber%20optic%20cables%20glowing%20warm%20orange%2C%20representing%20data%20and%20metrics%20debate%2C%20cinematic%2C%20industry%20analysis%2C%20no%20text&width=700&height=440&seq=flow-3-2026&orientation=landscape",
    title: "数据打投清朗之后：真实热度如何被重新定义",
    kind: "行业深度",
    summary: "当注水被围剿，讨论热度、话题量与口碑之间出现了新的换算关系。",
    read: "5.1k",
    like: "720",
  },
  {
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20clapperboard%20and%20film%20contracts%20on%20a%20director%20chair%20under%20warm%20stage%20light%2C%20moody%20cinematic%2C%20production%20shakeup%20narrative%2C%20no%20faces&width=700&height=440&seq=flow-4-2026&orientation=landscape",
    title: "剧组中途换角传闻：从立项到官宣的每一个内部信号",
    kind: "八卦追踪",
    summary: "选角、档期与合约文本之间，哪一处最容易漏出破绽被网友捕捉。",
    read: "4.7k",
    like: "688",
  },
  {
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20overhead%20of%20a%20wooden%20desk%20with%20green%20tea%20cup%20and%20stacked%20magazine%20archives%2C%20warm%20cinematic%20light%2C%20rumor%20mythology%20narrative%2C%20clean%20composition%2C%20no%20faces&width=700&height=440&seq=flow-5-2026&orientation=landscape",
    title: "那些流传多年的『陈年瓜』，是如何从论坛被一路带进短视频的",
    kind: "传播考古",
    summary: "一条老帖的二次焕新，背后是完整的搬运、拼贴与加料流水线。",
    read: "3.9k",
    like: "541",
  },
  {
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20dark%20photo%20of%20a%20television%20studio%20control%20room%20with%20multiple%20monitors%20showing%20blurred%20comment%20feeds%2C%20warm%20orange%20tone%2C%20editorial%20gatekeeping%20narrative%2C%20cinematic%2C%20no%20readable%20text&width=700&height=440&seq=flow-6-2026&orientation=landscape",
    title: "『被剪掉的那句话』：综艺剪辑如何成为最大争议制造机",
    kind: "方法论",
    summary: "正向引导与过度剪辑之间，评审与粉丝对同一画面的解读差了一整个宇宙。",
    read: "3.2k",
    like: "463",
  },
];

export const comments = [
  {
    user: "吃瓜不迷路",
    role: "考据派",
    time: "3小时前",
    stance: "中立",
    text: "我按时间线把几条爆料串起来对了一遍，早期考古那条真的是关键，很多讨论其实是在信息不全的情况下开始又结束的。图鉴式整理确实省事。",
    like: 328,
    replies: 41,
    repliesData: [
      { user: "互联网是有记忆的", text: "求后面更新完整版时间轴，已收藏蹲更新。" },
      { user: "理中客本人", text: "同意，语境真的很重要，光看截图的建议先翻全上下文。" },
    ],
  },
  {
    user: "前排小板凳",
    role: "围观党",
    time: "5小时前",
    stance: "站队",
    text: "其实最想看的是商务解约那块的节奏表，谁先跑谁观望这条线写得挺清楚，比那种只放情绪的开帖强多了。",
    like: 214,
    replies: 22,
    repliesData: [
      { user: "数据搬运工", text: "那段确实，品牌先后顺序基本能对应风险评级。" },
    ],
  },
  {
    user: "言论显微镜",
    role: "拆解党",
    time: "7小时前",
    stance: "质疑",
    text: "声明话术那段把『避重就轻』『全盘认领』做成对照挺有意思，希望这类方法论再多一点，少一点纯粹的情绪转发。",
    like: 187,
    replies: 18,
    repliesData: [],
  },
];

export const poll = {
  total: 128432,
  items: [
    { label: "支持图鉴式客观归档", value: 46, tone: "accent" },
    { label: "觉得过于中立无立场", value: 27, tone: "primary" },
    { label: "只想来蹲最新瓜", value: 27, tone: "secondary" },
  ],
};

export const navLinks = [
  { label: "首页", key: "#top", active: true },
  { label: "全网热榜", key: "#hot" },
  { label: "分类图鉴", key: "#catalog" },
  { label: "事件时间线", key: "#timeline" },
  { label: "热议现场", key: "#flow" },
  { label: "热评讨论", key: "#comments" },
];

export const cateTabs = [
  { label: "人物", icon: "ri-user-star-line" },
  { label: "事件", icon: "ri-sparkling-line" },
  { label: "类型", icon: "ri-price-tag-3-line" },
];

export const footerCates = [
  { label: "娱乐人物", count: 318 },
  { label: "选秀综艺", count: 264 },
  { label: "直播电商", count: 209 },
  { label: "影视剧集", count: 176 },
  { label: "商务解约", count: 142 },
  { label: "传播考古", count: 118 },
];